<template>
    <el-dialog title="声纹建模" :visible.sync="visible" width="600px" append-to-body :modal-append-to-body="false"
        :close-on-click-modal="false">
<!--        <div style="margin-top: 28px;margin-left: 55px;font-size: 16px;color:#6D7278;">{{ title }}</div>-->
        <div style="height: 200px;margin-left: 55px;">
            <!--            <el-steps :active="active" finish-status="success" simple>-->
            <!--                <el-step title="步骤 1"></el-step>-->
            <!--                <el-step title="步骤 2"></el-step>-->   
            <!--                <el-step title="步骤 3"></el-step>-->
            <!--            </el-steps>-->
            <el-form style="margin-top: 32px" label-position="left">
                <el-form-item label="模型名称">
                    <!--                    <el-input v-model="modelName"-->
                    <!--                              size="small"-->
                    <!--                              :fetch-suggestions="querySearch"-->
                    <!--                              @select="handleSelect"-->
                    <!--                              style="width: 300px"></el-input>-->
                    <el-autocomplete class="inline-input" v-model="modelName" style="width: 250px" size="small"
                        :fetch-suggestions="querySearch" placeholder="请输入模型名称" @select="handleSelect"
                        clearable></el-autocomplete>
                </el-form-item>
                <el-form-item label="样本类型">
                    <el-select v-model="sampleType" placeholder="请选择">
                        <el-option label="正样本" value="+1"/>
                        <el-option label="负样本" value="-1"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="remark" style="width: 390px;margin-left: 25px;"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button class="btn4" size="mini" @click="handleCancel">取消</el-button>
            <el-button class="btn3" size="mini" type="primary" @click="submitForm" :loading="isModeling">确定</el-button>


        </div>
    </el-dialog>
</template>

<script>


export default {
    data() {
        return {
            remark: '',
            title: '',
            visible: false,
            active: 0,
            modelName: "",
            sampleType: "+1",
            data: null,
            isModeling: false,
            historyModelList: []
        }
    },
    methods: {
        show(data) {
            console.log('data',data);
            this.visible = true;
            this.data = data;
            let params = {
                sensorId: data.sensorId
            }
            this.$api.yysy.listModel(params).then(res => {
                if (res.success) {
                    console.log(res.data);
                    this.historyModelList = [];
                    if (res.data.length > 0) {
                        res.data.forEach(item => {
                            this.historyModelList.push({
                                value: item.split("-")[0],
                            })
                        })
                    }
                }
            });
        },
        querySearch(queryString, cb) {
            cb(this.historyModelList);
        },
        handleSelect(item) {
            console.log(item);
        },
        handleCancel() {
            this.visible = false;
        },
        submitForm() {
            console.log('modelName', this.modelName);
            console.log('startPos', this.data.startPos);
            console.log('endPos', this.data.endPos);
            console.log('samplePath', this.data.samplePath);


            let modelExist = false;
            for (let i=0;i<this.historyModelList.length;i++){
                if (this.historyModelList[i].value === this.modelName){
                    modelExist = true;
                    break;
                }
            }

            if (modelExist) {
                this.$confirm("是否确认把当前样本追加到已有模型?", "模型已存在", {
                    cancelButtonText: "取消",
                    confirmButtonText: "确定",
                    type: "warning",
                    center: true,
                    showClose: false,
                }).then(() => {
                    this.doSubmit(true);
                })
            } else {
                this.doSubmit(false);
            }

        },
        doSubmit(append) {
            let params = {
                modelName: this.modelName,
                startPos: this.data.startPos,
                endPos: this.data.endPos,
                samplePath: this.data.samplePath,
                sensorId: this.data.sensorId,
                sampleType: this.sampleType,
                append: append
            };
            this.isModeling = true;
            this.$api.yysy
                .createModel(params)
                .then((res) => {
                    if (res.success) {
                        this.$message.success("模型创建成功!");
                        this.visible = false;
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.$message.error(err);
                })
                .finally(() => {
                    this.isModeling = false;
                });
            this.$emit("submit", this.modelName);
        },

    }
}
</script>

<style scoped>
.btn3 {
    width: 120px;
    height: 38px;
    background: #219E82;
    border-radius: 2px;
    border: 0.0625rem solid #219E82;
    color: white;
    cursor: pointer;
}

.btn3:hover {
    background: #44D7B6;
}

.btn4 {
    width: 120px;
    height: 38px;
    border-radius: 2px;
    border: 0.0625rem solid #44D7B6;
    background: transparent;
    color: #44D7B6;
    cursor: pointer;
}

.btn4:hover {
    background: #44D7B655;
}

/deep/ .el-autocomplete-suggestion__wrap.el-scrollbar__wrap {
    overflow: auto;
    background-color: #244447 !important;
    border: none;
}

</style>


// WEBPACK FOOTER //
// src/components/modelingDialog.vue